<template>
  <div>
    <single-select :list="list" @confirm="onConfirm" ref="content" />
  </div>
</template>

<script>
import SingleSelect from '@/questions/components/SingleSelect'

export default {
  name: 'MatrixSelectContent',
  components: { SingleSelect },
  props: {
    option: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    list() {
      return this.option.items.map(item => {
        return {
          label: item.content.text,
          value: item.id
        }
      })
    }
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      // 断点续答可能有值
      if (this.option.value) {
        this.$refs.content.changeValue(this.option.value)
      }
    })
  },
  methods: {
    onConfirm(val) {
      this.option.value = val.value
    }
  }
}
</script>
